import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

import { Grid, Typography, Paper, Box, Link } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "black",
  },
  paper: {
    padding: "20px",
    backgroundColor: "#283747",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
  },
  buttons: {
    margin: 30,
    width: "250px",
    color: "black",
  },
}));

export default function OxxoConfirmation(props) {
  const { responseData } = props;
  const dispatch = useDispatch();

  const classes = useStyles();
  const { t } = useTranslation("inscripcion");

  const monto = responseData.charges.data[0].amount / 100;
  const referencia = responseData.charges.data[0].payment_method.reference;
  return (
    <Grid
      container
      direction="row"
      style={{
        height: "auto",
        width: "100%",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        style={{
          height: "auto",
          width: "100%",
        }}
      >
        <Typography
          color="primary"
          gutterBottom
          variant={"subtitle"}
          component="h6"
        >
          {t("oxxo.felicidadesCompletaste")}
        </Typography>
        <Typography
          color="primary"
          gutterBottom
          variant={"subtitle"}
          component="h4"
        >
          {t("oxxo.fichaOxxoAviso")}
        </Typography>

        <Typography
          color="primary"
          gutterBottom
          variant={"subtitle"}
          component="h6"
        >
          {t("oxxo.vigenciaPrefijo")}
          <b>{t("oxxo.horas48")}</b>
          {t("oxxo.vigenciaSufijo")}
        </Typography>

        <Box maxWidth={600} mx="auto" p={2} border={1} borderRadius={8} borderColor="#ccc">
          {/* Encabezado negro */}
          <Box bgcolor="black" py={1}>
            <Typography variant="body2" align="center" style={{ color: 'white', fontWeight: 'bold' }}>
              {t("oxxo.fichaDigital")}
            </Typography>
          </Box>

          {/* Logo + Monto */}
          <Grid container spacing={2} justify="center" alignItems="center" style={{ marginTop: 16 }}>
            <Grid item xs={12} sm={5} style={{ textAlign: 'center' }}>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/oxxo_brand%2Foxxopay_brand.png?alt=media&token=a855a8cf-817f-4036-a34a-ddf926e54fad"
                alt="OXXOPay"
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            </Grid>
            <Grid item xs={12} sm={7} style={{ textAlign: 'center' }}>
              <Typography variant="subtitle2" gutterBottom>
                {t("oxxo.montoAPagar")}
              </Typography>
              <Typography variant="h4" style={{ fontWeight: 'bold' }}>
                ${monto} <sup style={{ fontSize: '16px' }}>MXN</sup>
              </Typography>
              <Typography variant="body2" style={{ marginTop: 4 }}>
                {t("oxxo.comisionAdicional")}
              </Typography>
            </Grid>
          </Grid>

          {/* Referencia */}
          <Box mt={4} textAlign="center">
            <Typography variant="subtitle1" gutterBottom style={{ color: '#f44336' }}>
              {t("oxxo.referencia")}
            </Typography>
            <Typography variant="h3" style={{ color: '#f44336', fontWeight: 'bold', wordBreak: 'break-word' }}>
              {referencia}
            </Typography>
          </Box>

          {/* Instrucciones */}
          <Box mt={4} borderTop={1} pt={3} borderColor="#ccc">
            <Typography
              variant="h5"
              gutterBottom
              align="center"
              style={{ color: '#f44336', fontWeight: 'bold' }}
            >
              {t("oxxo.instrucciones")}
            </Typography>
            <Box component="ol" pl={2}>
              <Box component="li" mb={1}>
                <Typography variant="body2">
                  {t("oxxo.paso1Prefijo")}
                  <Link href="https://www.google.com.mx/maps/search/oxxo/" target="_blank" rel="noopener" style={{ color: '#2196f3' }}>
                    {t("oxxo.paso1Link")}
                  </Link>
                </Typography>
              </Box>
              <Box component="li" mb={1}>
                <Typography variant="body2">
                  {t("oxxo.paso2Prefijo")}
                  <strong style={{ color: '#f44336' }}>OXXOPay</strong>
                  {t("oxxo.paso2Sufijo")}
                </Typography>
              </Box>
              <Box component="li" mb={1}>
                <Typography variant="body2">
                  {t("oxxo.paso3")}
                </Typography>
              </Box>
              <Box component="li" mb={1}>
                <Typography variant="body2">{t("oxxo.paso4")}</Typography>
              </Box>
              <Box component="li" mb={1}>
                <Typography variant="body2">
                  {t("oxxo.paso5Prefijo")}
                  <strong>
                    {t("oxxo.paso5Destacado")}
                  </strong>
                </Typography>
              </Box>
            </Box>

            <Box mt={2}>
              <Typography variant="caption" align="center" display="block">
                {t("oxxo.footerPrefijo")}<strong>Dashport</strong>{t("oxxo.footerSufijo")}
              </Typography>
            </Box>
          </Box>
        </Box>

      </Grid>
    </Grid>
  );
}
